module.exports = __webpack_public_path__ + "img/map_illustrate.c3f4fd43.svg";